// Los valores históricos se conservan aunque cambie su nombre visible.
export const STUDENT_SCHOOL_GROUPS = [
  {
    label: 'Bachillerato Anual',
    options: [
      { value: 'nueva generacion', label: 'Nueva Generación' },
      { value: 'san agustin', label: 'San Agustín' },
      { value: 'san bartolome', label: 'San Bartolomé' },
      { value: 'iberoamericano', label: 'Instituto Iberoamericano Anual' },
      { value: 'inecol', label: 'Inecol' },
      { value: 'klazia international school', label: 'Klazia International School Jovenes' },
    ],
  },
  {
    label: 'Bachillerato Semestralizado',
    options: [
      { value: 'instituto iberoamerica clei', label: 'Instituto Iberoamericano CLEI' },
      { value: 'coglobal', label: 'COGLOBAL' },
      { value: 'los andes', label: 'Colegio International los Andes' },
      { value: 'colegio iberoamericano', label: 'Colegio Iberoamericano' },
      { value: 'klazia international school adultos', label: 'Klazia International School Adultos' },
    ],
  },
  {
    label: 'Técnicos',
    options: [
      { value: 'instituto tecnico iberoamericano', label: 'Instituto Técnico Iberoamericano' },
      { value: 'eductec', label: 'Edutec' },
      { value: 'fundetec', label: 'Fundetec' },
    ],
  },
];
export const STUDENT_SCHOOL_OPTIONS = STUDENT_SCHOOL_GROUPS.flatMap(group => group.options);
const LEGACY_OPTIONS = [
  { value: 'educamos con valores', label: 'Educamos con Valores (histórico)' },
  { value: 'getsemani', label: 'Getsemaní (histórico)' },
];
export const STUDENT_SCHOOL_FILTER_OPTIONS = [...STUDENT_SCHOOL_OPTIONS, ...LEGACY_OPTIONS];
export function getStudentSchoolGroups(currentValue) {
  const historical = LEGACY_OPTIONS.filter(option => option.value === currentValue)
    .map(option => ({ ...option, disabled: true }));
  return [...STUDENT_SCHOOL_GROUPS, ...(historical.length ? [{ label: 'Colegios históricos', options: historical }] : [])];
}
export function getStudentSchoolOptions(currentValue) {
  return getStudentSchoolGroups(currentValue).flatMap(group => group.options);
}
export function isKlaziaInternationalSchool(value) {
  return ['klazia international school', 'klazia international school adultos'].includes(value);
}
